import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routerMap = new Router({
  routes: [
    {
      path: '',
      component: () => import('@/views/login')
    },
    {
      path: '/login', // 登录
      leftNavType: 'login',
      name: 'login',
      component: () => import('@/views/login')
    },
    {
      path: '/homePage1', // 登录首页
      leftNavType: 'homePage1',
      name: 'homePage1',
      component: () => import('@/views/homePage1')
    },

    {
      path: '/screenMonitors', // 大屏
      leftNavType: 'screenMonitors',
      name: 'screenMonitors',
      component: () => import('@/views/screenMonitors')
    },
    {
      path: '/layout',
      leftNavType: 'layout',
      meta: {
        leftNavType: 'layout'
      },
      name: 'layout',
      component: () => import('@/components/layout/layout'),
      children: [
        {
          path: '/homePage',
          title: '首页',
          name: 'homePage',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/home/index')
        },

        {
          path: '/index2',
          title: '分组详情',
          name: 'index2',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/home/index2')
        },
        {
          path: '/userManagement',
          title: '用户管理',
          name: 'userManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/systemManagement/userManagement')
        },
        {
          path: '/timedTask',
          title: '定时任务',
          name: 'timedTask',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/timedTask/index')
        },
        {
          path: '/approval',
          title: '审批',
          name: 'approval', // 审批
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/approval/approval')
        },
        {
          path: '/approvalTemplate',
          title: '审批模板',
          name: 'approvalTemplate', // 审批模板
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/approvalManagement/approvalTemplate')
        },
        {
          path: '/approvalConfiguration',
          title: '审批配置',
          name: 'approvalConfiguration', // 审批配置
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字approvalRecord
          component: () => import('@/views/approvalManagement/approvalConfiguration')
        },
        {
          path: '/greenhouseManagement',
          title: '审批配置',
          name: 'greenhouseManagement', // 审批配置
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字approvalRecord
          component: () => import('@/views/dataAnalysisManagement/greenhouseManagement')
        },
        {
          path: '/approvalRecord',
          title: '审批记录',
          name: 'approvalRecord', // 审批记录
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字ss
          component: () => import('@/views/approvalManagement/approvalRecord')
        },
        {
          path: '/intelligentControl',
          title: '智慧控制',
          name: 'intelligentControl',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/intelligentControl/intelligentControl')
        },
        {
          path: '/intelligentControl0',
          name: 'intelligentControl0',
          component: () => import('@/views/intelligentControl/intelligentControl0')
        },
        {
          path: 'linkagecenter1',
          name: 'Linkagecenter1',
          component: resolve => require(['@/views/equipmentcenter/linkagecenter1'], resolve),
          meta: {
            title: '添加控制'
          }
        },
        {
          path: 'linkagecenter2',
          name: 'Linkagecenter2',
          component: resolve => require(['@/views/equipmentcenter/linkagecenter2'], resolve),
          meta: {
            title: '添加满足条件'
          }
        },
        {
          path: 'linkagecenter3',
          name: 'Linkagecenter3',
          component: resolve => require(['@/views/equipmentcenter/linkagecenter3'], resolve),
          meta: {
            title: '添加执行动作'
          }
        },
        {
          path: 'linkagecenter4',
          name: 'Linkagecenter4',
          component: resolve => require(['@/views/equipmentcenter/linkagecenter4'], resolve),
          meta: {
            title: '添加满足条件(自动)'
          }
        },
        {
          path: '/alarmPredictions',
          title: '告警预报',
          name: 'alarmPredictions', //  告警
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/alarmPrediction/alarmPredictions')
        },
        {
          path: '/alarmStatistics',
          title: '告警统计',
          name: 'alarmStatistics', //  告警
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/alarmPrediction/alarmStatistics')
        },
        {
          path: '/fertilizerManagement',
          title: '水肥一体化',
          name: 'fertilizerManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/fertilizerManagement/fertilizerManagement')
        },
        {
          path: '/rotation',
          title: '水肥一体化',
          name: 'rotation',
          component: () => import('@/views/fertilizerManagement/rotation')
        },
        {
          path: '/fertilizerManagement2',
          title: '水肥一体化',
          name: 'fertilizerManagement2',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/fertilizerManagement/fertilizerManagement2')
        },
        {
          path: '/waterPipe',
          title: '水管',
          name: 'waterPipe',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/fertilizerManagement/waterPipe')
        },
        {
          path: '/irrigationProportion',
          title: '配比',
          name: 'irrigationProportion',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/fertilizerManagement/irrigationProportion')
        },
        {
          path: '/amendantRecord',
          title: '修改记录',
          name: 'amendantRecord',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/fertilizerManagement/amendantRecord')
        },
        {
          path: '/growthModel',
          title: '生长模型',
          name: 'growthModel',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModel')
        },
        {
          path: '/growthModelManagement',
          title: '作物生长模型',
          name: 'growthModelManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelManagement')
        },
        {
          path: '/growthStageManagement',
          title: '生长模型列表',
          name: 'growthStageManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthStageManagement')
        },
        {
          path: '/historicalModelManagement',
          title: '作物历史模型',
          name: 'historicalModelManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/historicalModelManagement')
        },
        {
          path: '/historicalDetailsManagement',
          title: '作物历史模型',
          name: 'historicalDetailsManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/historicalDetailsManagement')
        },
        {
          path: '/growthModelEvnManagement',
          title: '生长模型环境',
          name: 'growthModelEvnManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelEvnManagement')
        },
        {
          path: '/growthModelEvnParamManagement',
          title: '生长模型环境参数',
          name: 'growthModelEvnParamManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelEvnParamManagement')
        },
        {
          path: '/growthModelParamDeviceManagement',
          title: '生长模型环境参数设备',
          name: 'growthModelParamDeviceManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelParamDeviceManagement')
        },
        {
          path: '/growthModelDeviceNumericalManagement',
          title: '生长模型环境数值设备（传感器）',
          name: 'growthModelDeviceNumericalManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelDeviceNumericalManagement')
        },
        {
          path: '/growthModelDeviceSwitchManagement',
          title: '生长模型环境开关设备（控制器）',
          name: 'growthModelDeviceSwitchManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelDeviceSwitchManagement')
        },
        {
          path: '/growthModelStageControlManagement',
          title: '生长模型环境阶段控制器',
          name: 'growthModelStageControlManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelStageControlManagement')
        },
        {
          path: '/growthModelStageDeviceOutManagement',
          title: '生长模型环境阶段外部设备',
          name: 'growthModelStageDeviceOutManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelStageDeviceOutManagement')
        },
        {
          path: '/growthModelStageDeviceManagement',
          title: '生长模型环境阶段设备',
          name: 'growthModelStageDeviceManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelStageDeviceManagement')
        },
        {
          path: '/growthModelStageControlDeviceManagement',
          title: '生长模型阶段控制参数设备',
          name: 'growthModelStageControlDeviceManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelStageControlDeviceManagement')
        },
        {
          path: '/growthModelPartControlDeviceManagement',
          title: '生长模型局部控制设备',
          name: 'growthModelPartControlDeviceManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelPartControlDeviceManagement')
        },
        {
          path: '/growthModelStageControlPriorityManagement',
          title: '生长模型阶段控制优先级',
          name: 'growthModelStageControlPriorityManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelStageControlPriorityManagement')
        },
        {
          path: '/irrigationRecord',
          title: '灌溉记录',
          name: 'irrigationRecord',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/fertilizerManagement/irrigationRecord')
        },
        {
          path: '/decisionManagement',
          title: '决策模板',
          name: 'decisionManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/decisionManagement')
        },
        {
          path: '/aiModal',
          title: '决策模板',
          name: 'aiModal',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/aiModal')
        },
        {
          path: '/modificationManagement',
          title: '修改记录',
          name: 'modificationManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/modificationManagement')
        },
        {
          path: '/cropsManagement',
          title: '修改记录',
          name: 'cropsManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/cropsManagement/cropsManagement')
        },
        {
          path: '/deviceManagement',
          title: '修改记录',
          name: 'deviceManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/deviceManagement')
        },
        {
          path: '/addSensorManagement',
          title: '生长模型列表',
          name: 'addSensorManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/addSensorManagement')
        },
        {
          path: '/historicalSensorManagement',
          title: '水肥一体化',
          name: 'historicalSensorManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/historicalSensorManagement')
        },
        {
          path: '/addCameraManagement',
          title: '水肥一体化',
          name: 'addCameraManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/addCameraManagement')
        },
        {
          path: '/addControlManagement',
          title: '水肥一体化',
          name: 'addControlManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/addControlManagement')
        },
        {
          path: '/addGatewayManagement',
          title: '水肥一体化',
          name: 'addGatewayManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/addGatewayManagement')
        },
        {
          path: '/dataAnalysisManagement',
          title: '全国地图',
          name: 'dataAnalysisManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/dataAnalysisManagement/dataAnalysisManagement')
        },
        {
          path: '/regionalMapManagement',
          title: '水肥一体化',
          name: 'regionalMapManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/dataAnalysisManagement/regionalMapManagement')
        },
        {
          path: '/groupFarm',
          title: '农事记录',
          name: 'groupFarm',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/groupFarm')
        },
        {
          path: '/cropType',
          title: '农事类型',
          name: 'cropType',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/cropType')
        },
        {
          path: '/crop',
          title: '作物信息',
          name: 'crop',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/crop')
        },
        {
          path: '/cropDevice',
          title: '农事设备',
          name: 'crop',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/cropDevice')
        },
        {
          path: '/cropPesticide',
          title: '农药信息',
          name: 'crop',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/cropPesticide')
        },
        {
          path: '/cropProductionFertilizer',
          title: '肥料信息',
          name: 'crop',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/cropProductionFertilizer')
        },
        {
          path: '/cropStaff',
          title: '员工信息',
          name: 'crop',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/groupAlarm/cropStaff')
        },

        {
          path: '/planManagement',
          title: '方案',
          name: 'planManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/photosynthesis/planManagement')
        },
        {
          path: '/groupPlanManagement',
          title: '分组方案',
          name: 'groupPlanManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/photosynthesis/groupPlanManagement')
        },
        {
          path: '/homeParam',
          title: '参数配置',
          name: 'homeParam',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/homeParam/homeParam')
        },
        {
          path: '/homeParamType',
          title: '参数类型',
          name: 'homeParamType',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/homeParam/homeParamType')
        },
        {
          path: '/homeGroupParam',
          title: '分组参数',
          name: 'homeGroupParam',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/homeParam/homeGroupParam')
        },
        {
          path: '/homeGroupParamDevice',
          title: '分组参数设备',
          name: 'homeGroupParamDevice',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/homeParam/homeGroupParamDevice')
        },
        {
          path: '/groupPlan',
          title: '决策模型-光合作用',
          name: 'groupPlan',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/photosynthesis/groupPlan')
        },
        {
          path: '/growthModelHisParamControl',
          title: '决策模型-历史参数控制',
          name: 'growthModelHisParamControl',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthModelHisParamControl')
        },
        {
          path: '/growthModelHisParamControlNumerical',
          title: '决策模型-历史参数控制-阶段传感器',
          name: 'growthModelHisParamControlNumerical',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthModelHisParamControlNumerical')
        },
        {
          path: '/growthModelHisParamControlChart',
          title: '决策模型-历史参数比对图表',
          name: 'growthModelHisParamControlChart',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthModelHisParamControlChart')
        },
        {
          path: '/growthModelHisParamControlChart_1',
          title: '决策模型-历史参数比对图表',
          name: 'growthModelHisParamControlChart_1',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthModelHisParamControlChart_1')
        },
        {
          path: '/growthDataHisCrop',
          title: '决策模型-生长记录',
          name: 'growthDataHisCrop',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthDataHisCrop')
        },
        {
          path: '/growthModelWeather',
          title: '决策模型-天气',
          name: 'growthModelWeather',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthModelWeather')
        },
        {
          path: '/growthModelTimer',
          title: '决策模型-调控记录',
          name: 'growthModelTimer',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/growthModelTimer')
        },
        {
          path: '/homeGroup',
          title: '首页-首页分组配置',
          name: 'homeGroup',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/homeParam/homeGroup')
        },
        {
          path: '/deviceGroupPosition',
          title: '设备-设备分组位置配置',
          name: 'deviceGroupPosition',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/deviceGroupPosition')
        },
        {
          path: '/deviceGroupPositionBatch',
          title: '设备-设备分组位置批量配置',
          name: 'deviceGroupPositionBatch',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/deviceGroupPositionBatch')
        },
        {
          path: '/groupManagement',
          title: '设备分组',
          name: 'groupManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/deviceManagement/groupManagement')
        },
        {
          path: '/deviceAlarm',
          title: '设备告警配置',
          name: 'deviceAlarm',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/alarmPrediction/deviceAlarm')
        },
        {
          path: '/deviceOffline',
          title: '设备离线配置',
          name: 'deviceOffline',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/alarmPrediction/deviceOffline')
        },
        {
          path: '/childManagement',
          title: '子账号',
          name: 'childManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/components/systemManagement/childManagement')
        },
        {
          path: '/addDecisionModel',
          title: '添加决策模型',
          name: 'addDecisionModel',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/addDecisionModel')
        },
        {
          path: '/relationEvnModel',
          title: '关联环境模型',
          name: 'relationEvnModel',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/relationEvnModel')
        },
        {
          path: '/relationGrowthModel',
          title: '关联生长模型',
          name: 'relationGrowthModel',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/relationGrowthModel')
        },
        {
          path: '/bandingCity',
          title: '绑定城市',
          name: 'bandingCity',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/bandingCity')
        },
        {
          path: '/bandingVideo',
          title: '绑定摄像头',
          name: 'bandingVideo',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/bandingVideo')
        },
        {
          path: '/addDeviceControl',
          title: '添加设备调控',
          name: 'addDeviceControl',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/addDeviceControl')
        },
        {
          path: '/addGroupAlarm',
          title: '添加分组告警',
          name: 'addGroupAlarm',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/decisionManagement/step/addGroupAlarm')
        },
        {
          path: '/addEvnModel',
          title: '添加环境模型',
          name: 'addEvnModel',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/step/addEvnModel')
        },
        {
          path: '/addEvnParam',
          title: '添加环境参数',
          name: 'addEvnParam',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/step/addEvnParam')
        },
        {
          path: '/addDeviceNumerical',
          title: '环境传感器',
          name: 'addDeviceNumerical',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/step/addDeviceNumerical')
        },
        {
          path: '/addDeviceSwitch',
          title: '执行控制器',
          name: 'addDeviceSwitch',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/step/addDeviceSwitch')
        },
        {
          path: '/addStageControl',
          title: '阶段控参数',
          name: 'addStageControl',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/step/addStageControl')
        },
        {
          path: '/growthModelUserLog',
          title: '生长模型-使用记录',
          name: 'growthModelUserLog',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelUserLog')
        },
        {
          path: '/growthUserManagement',
          title: '授权用户',
          name: 'growthUserManagement',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelUserManagement')
        },
        {
          path: '/growthModelFertilizerUser',
          title: '肥料模型用户',
          name: 'growthModelFertilizerUser',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelFertilizerUser')
        },
        {
          path: '/growthModelGrowthFertilizer',
          title: '肥料模型用户',
          name: 'growthModelGrowthFertilizer',
          iconImg: 'icon_img1', // 菜单图标
          iconName: 'shouye', // 菜单图标 icon class名字
          component: () => import('@/views/growthModelManagement/growthModelGrowthFertilizer')
        }
      ]
    }
  ]
})
export default routerMap
